import PropTypes from 'prop-types';

// Estilos
import estilos from './background.module.css';

// Datos
import imgBackground from '../../../assets/imgs/fondo_4_5.png';


function Background(props){
    return (
        <div id={estilos.encapsulador}>
            <img
                alt = 'logo de FinoFinoEstudio®'
                id={estilos.imagen} 
                src={imgBackground} 
                className={props.verImagen ? '' : estilos.hidden} 
            />
            {props.children}
        </div>
    );
}

Background.propTypes = {
    verImagen : PropTypes.bool,
    children : PropTypes.any
}

export default Background;